import { useCallback, useState, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import clsx from "clsx";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { makeStyles } from "@material-ui/core/styles";

import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  Typography,
} from "@material-ui/core";

import { Email } from "@material-ui/icons";

import DialogTermsOfUse from "./components/terms-of-use";
import DialogPrivacyPolicies from "./components/privacy-policies";
import componentStyles from "assets/theme/views/auth/login";
import componentStylesButtons from "assets/theme/components/button";
import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { IsMobile } from "utils/is-mobile";
import PasswordField from "components/_refactor/fields/password";
import InputText from "components/_refactor/text/input";
import {
  preloadStructureData,
  getBrandsData,
} from "hooks/useStructureQueries";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(componentStylesButtons);

function Alert({ text, closeAlert }) {
  return (
    <ReactBSAlert
      error
      style={{ display: "block", marginTop: "-100px" }}
      title="Ops"
      onConfirm={closeAlert}
      onCancel={closeAlert}
      confirmBtnBsStyle="info"
      confirmBtnText="Ok"
      btnSize=""
      confirmBtnStyle={{
        marginRight: undefined,
        borderColor: undefined,
        boxShadow: undefined,
      }}
    >
      {text}
    </ReactBSAlert>
  );
}

const rememberUserLS = localStorage.getItem("usuarioLembrarMe");

let redirectCallback = () => {};

export default function Login() {
  const classes = {
    ...useStyles(),
    ...useStylesButtons(),
  };
  const snackbar = useSnackbar();

  const isMobile = IsMobile();

  const [email, setEmail] = useState(rememberUserLS || "");
  const [password, setPassword] = useState("");
  const location = useLocation();
  const [alert, setalert] = useState(false);
  const [loadingAuth, setLoadingAuth] = useState(false);
  const [rememberUser, setRememberUser] = useState(Boolean(rememberUserLS));
  const [openTermsDialog, setOpenTermsDialog] = useState(false);
  const [openPrivacyPoliciesDialog, setOpenPrivacyPoliciesDialog] =
    useState(false);

  const closeAlert = useCallback(() => setalert(null), []);

  const handleRememberChange = (event) => {
    setRememberUser(event.target.checked);
  };

  const history = useHistory();

  function validateForm() {
    return MaskAndValid.validateEmail(email) && password.length > 4;
  }

  const doLoginRedirect = useCallback(() => {
    if (rememberUser) {
      localStorage.setItem("usuarioLembrarMe", email);
    } else {
      localStorage.removeItem("usuarioLembrarMe");
    }

    if (window.location.href.includes("karsten-portal-b2b-test")) {
      history.push(
        process.env.PUBLIC_URL +
          "/index.html?" +
          (location.state?.location?.pathname || "home") +
          (location.state?.location?.search?.replace("?", "") || "")
      );
    } else {
      history.go(
        process.env.PUBLIC_URL +
          (location.state?.location?.pathname === undefined
            ? "/home"
            : location.state?.location?.pathname) +
          location.state?.location?.search ===
          undefined
          ? ""
          : location.state?.location?.search
      );
    }
  }, [
    email,
    location.state?.location?.pathname,
    location.state?.location?.search,
    rememberUser,
  ]);

  const handleTermsAccept = () => {
    setOpenTermsDialog(false);
    setOpenPrivacyPoliciesDialog(true);
  };

  const handlePrivacyPoliciesAccept = useCallback(() => {
    if (redirectCallback) {
      redirectCallback();
    }

    doLoginRedirect();
    setTimeout(() => {
      preloadStructureData().catch((error) => {
        console.error("Erro ao pré-carregar dados de estrutura:", error);
      });
    }, 500);
  }, [doLoginRedirect]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoadingAuth(true);

    const formData = new FormData();
    formData.append("login", email);
    formData.append("password", password);

    const object = {};
    formData?.forEach(function (value, key) {
      object[key] = value;
    });

    await Api.post("sign-in", "login", object, false)
      .then(async (retorno) => {
        if (retorno?.Result?.IdUser) {
          let foundError;
          let userAcceptedTerms = false;

          localStorage.setItem("k-user", retorno.Result.IdUser);
          await Api.get("user-detail", "login", "", true)
            .then((value) => {
              userAcceptedTerms = value.Result.TermoUsoAceito;

              const setSessionStorage = () => {
                localStorage.setItem("loggedIn", true);

                localStorage.setItem(
                  "sessoesMenuUser",
                  JSON.stringify(value.Result.SessoesMenu || [])
                );
                localStorage.setItem(
                  "viewsMenuUser",
                  JSON.stringify(value.Result.ViewsMenu || [])
                );
                localStorage.setItem(
                  "userDetail",
                  JSON.stringify(value.Result || [])
                );
                localStorage.setItem(
                  "userProfiles",
                  JSON.stringify(value.Result.UsuarioPerfis || [])
                );
              };

              if (userAcceptedTerms) {
                setSessionStorage();
                redirectCallback = null;
              } else {
                redirectCallback = setSessionStorage;
              }
            })
            .catch((error) => {
              console.log(error);
              foundError = error;
              setalert(
                <Alert
                  text="Ocorreu um erro ao buscar as informações do Usuário!"
                  closeAlert={closeAlert}
                />
              );
              setLoadingAuth(false);
            });

          try {
            const brandsResult = await getBrandsData();
            localStorage.setItem(
              "usuarioMarcas",
              JSON.stringify(brandsResult || [])
            );
          } catch (error) {
            console.log(error);
            foundError = error;
            setalert(
              <Alert
                text="Ocorreu um erro ao buscar as marcas do Usuário!"
                closeAlert={closeAlert}
              />
            );
            setLoadingAuth(false);
          }

          setLoadingAuth(false);

          if (!foundError && userAcceptedTerms) {
            doLoginRedirect(location);
            setTimeout(() => {
              preloadStructureData().catch((error) => {
                console.error("Erro ao pré-carregar dados de estrutura:", error);
              });
            }, 500);
          } else if (!userAcceptedTerms) {
            setOpenTermsDialog(true);
          }
        }
      })
      .catch((error) => {
        setalert(<Alert text={error} closeAlert={closeAlert} />);
        setLoadingAuth(false);
      });
  };

  useEffect(() => {
    const sessionExpiredMessage = localStorage.getItem("sessionExpiredMessage");
    const sessionExpired = localStorage.getItem("sessionExpired");

    if (sessionExpiredMessage) {
      snackbar.showMessage(sessionExpiredMessage, {
        severity: "error",
      });
      localStorage.removeItem("sessionExpiredMessage");
    } else {
      if (sessionExpired && JSON.parse(sessionExpired)) {
        snackbar.showMessage("Sessão expirada, faça o login novamente", {
          severity: "error",
        });
        localStorage.removeItem("sessionExpired");
      }
    }
  }, []);

  return (
    <>
      {alert}

      <Container
        maxWidth="sm"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Card classes={{ root: classes.card }}>
          <CardHeader
            className={classes.cardHeader}
            title="Informe os dados de acesso"
            titleTypographyProps={{
              component: Typography,
              variant: "h4",
              color: "textSecondary",
              align: "center",
            }}
          />

          <CardContent classes={{ root: classes.cardContent }}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <InputText
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                    startAdornment={<Email />}
                    white
                  />
                </Grid>

                <Grid item xs={12}>
                  <PasswordField
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    white
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    value="end"
                    control={
                      <Checkbox
                        checked={rememberUser}
                        onChange={handleRememberChange}
                        color="default"
                      />
                    }
                    label="Lembrar meu usuário"
                    labelPlacement="end"
                    classes={{
                      root: classes.formControlLabelRoot,
                      label: classes.formControlLabelLabel,
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box display="flex" justifyContent="center">
                    <Button
                      variant="contained"
                      classes={{ root: classes.buttonContainedInfo }}
                      type="submit"
                      disabled={loadingAuth}
                      style={isMobile ? { width: "100%" } : { width: "15vw" }}
                    >
                      Login
                    </Button>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Grid container component={Box} marginTop="1rem">
                    <Grid
                      item
                      xs={isMobile ? 12 : 6}
                      component={Box}
                      textAlign={isMobile ? "center" : "left"}
                      style={{ marginBottom: isMobile ? "1.5rem" : 0 }}
                    >
                      <Link
                        to={`forgot-my-password/?email=${email}`}
                        className={clsx(classes.footerLinks)}
                      >
                        Esqueceu a senha?
                      </Link>
                    </Grid>
                    <Grid
                      item
                      xs={isMobile ? 12 : 6}
                      component={Box}
                      textAlign={isMobile ? "center" : "right"}
                    >
                      <Link
                        to={"sign-up"}
                        className={clsx(classes.footerLinks)}
                      >
                        Criar uma nova conta
                      </Link>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>

        <Box component={Grid} container justifyContent="center">
          <Grid item xs={12} lg={5} md={7}>
            <Grid container component={Box} marginTop="1rem">
              <Grid item xs={12} component={Box} textAlign="center">
                <Link to="termos-de-uso" className={clsx(classes.footerLinks)}>
                  Termos de Uso
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        {openPrivacyPoliciesDialog && (
          <DialogPrivacyPolicies
            open={openPrivacyPoliciesDialog}
            handleClose={() => setOpenPrivacyPoliciesDialog(false)}
            onAccept={handlePrivacyPoliciesAccept}
          />
        )}
        {openTermsDialog && (
          <DialogTermsOfUse
            open={openTermsDialog}
            handleClose={() => setOpenTermsDialog(false)}
            onAccept={handleTermsAccept}
          />
        )}
      </Container>
    </>
  );
}
